<template>
    <div v-if="dataSource && dataSourceType === 'InnerDocument'"
        :key="document.id"
        class="p-relative"
    >

        <Toolbar :menu="dataSource.Data.Menu" v-on:toolbar-button-click="onToolbarClick"  />
        <DocumentPanel :document-info="dataSource.Data.Object" />

        <div class="d-flex after-tabs-part-wrapper">
            <v-tabs
                v-model="tab"
                background-color="transparent"
                slider-size="3"
                class="tab-selector-panel"
                mobile-breakpoint="0"
            >
                <v-tabs-slider color="#E43958"></v-tabs-slider>

                <v-tab 
                    v-for="item in pages"
                    :key="document.id + item.FormId"
                    @click="onTabClicked(item.FormId)"
                >
                    <template v-if="item.Count < 0">
                        {{ item.Name }}
                    </template> 
                    <template v-else>
                        {{ item.Name }}
                        <span class="count" id="attachCounter">{{item.Count}}</span>
                    </template>   
                </v-tab>

            </v-tabs>
            
            <div
                v-if="isViewMode && document.Version && (document.RegState === 0 || document.RegState === 3 || document.RegState === 5 || document.RegState === 6)"
                class="after-tabs-part"
            >
                <v-doc-version-chip :id="document.id" :text="$t('Версии')" />
            </div>

        </div>

        <v-tabs-items
            v-model="tab"
            class="tab-content-panel"
        >
            <v-tab-item 
                v-for="item in pages"
                :key="document.id + item.FormId"
            >
                <template v-if="item.FormId == document.id">
                    <v-form class="wrapperForm" ref="form" lazy-validation>
                        <v-row dense>
                            <v-col cols="12" sm="12" md="6" class="section-wrapper">
                                
                                <!--Секция Сведения о регистрации-->
                                <v-card flat v-if="isRegistered">
                                    <v-card-text>
                                        <div class="form-box-title">{{$t("Сведения_о_регистрации")}}</div>

                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Журнал_регистрации")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div class="onlyReadData">{{ document.Counter ? document.Counter.Name : '' }}</div>
                                            </v-col>
                                        </v-row>

                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Исходящий_номер,_дата")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div class="onlyReadData">{{ concatedRegistrationData  }}</div>
                                            </v-col>
                                        </v-row>

                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Регистратор")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div class="onlyReadData">
                                                    <v-workplace-chip :id="document.Card.RegistratorWorkplaceId" :name="document.Card.RegistratorName" />
                                                </div>
                                            </v-col>
                                        </v-row>

                                    </v-card-text>
                                </v-card>

                                <!--Секция Реквизиты документа-->
                                <v-card flat>
                                    <v-card-text>
                                        <div class="form-box-title">{{$t("Реквизиты_документа")}}</div>

                                        <!--поле Номер проекта (всегда просмотр)-->
                                        <v-row no-gutters v-if="!document.is_new_record">
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Номер_проекта")}}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <div class="onlyReadData">{{ document.Card.DraftNumber }}</div>
                                            </v-col>
                                        </v-row>
                                        
                                        <!--поле Тип внешнего контроля (только для ОРД)-->
                                        <v-row no-gutters v-if="isORD">
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Тип_внешнего_контроля")}}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{document.Card.OuterControlType ? document.Card.OuterControlType.Value : $t("не_указано")}}
                                                </div>
                                                <v-autocomplete
                                                    v-else
                                                    :value="document.Card.OuterControlType"
                                                    @input="update({ property: 'Data.Object.Document.Card.OuterControlType', value: $event })"
                                                    :items="GetReference(1027)"
                                                    :item-text="item => $refLocale(item, $i18n.locale)"
                                                    item-value="id"
                                                    return-object
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="requiredRule"
                                                    append-icon="fas fa-chevron-down"
                                                >
                                                </v-autocomplete>
                                            </v-col>
                                        </v-row>

                                        <!--поле Протокол-->
                                        <v-row no-gutters v-if="!isORD && !isViewMode && !isCommon && userInfo.permissions.includes('CreateProtocol')">
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Протокол")}}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <v-switch
                                                    v-model="isProtocol"
                                                    inset
                                                    hide-details
                                                    class="cust-switch"
                                                />
                                            </v-col>
                                        </v-row>

                                        <!--поле Номенклатура-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Номенклатура")}}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{document.Nomenclature ? `${document.Nomenclature.Code} ${document.Nomenclature.Header}` : $t("не_указано")}}
                                                </div>
                                                <!-- <template v-else>
                                                    <div class="icon-click-row-group">
                                                        <div @click="onNomenclatureSelect">
                                                            <v-icon small v-tooltip.left-center="selectNomenclatureTooltip">
                                                                fas fa-edit
                                                            </v-icon>
                                                        </div>
                                                        <v-textarea
                                                            class="oneRowStartTextarea"
                                                            rows="1"
                                                            auto-grow
                                                            row-height="16"
                                                            no-resize
                                                            hide-details
                                                            required
                                                            outlined
                                                            dense
                                                            readonly
                                                            :value="document.Nomenclature ? `${document.Nomenclature.Code} ${document.Nomenclature.Header}` : ''"
                                                            :rules="requiredRule"
                                                        >
                                                        </v-textarea>
                                                    </div>
                                                </template> -->
                                                <v-select
                                                    v-else
                                                    :value="document.NomenclatureId != guidEmpty ? document.NomenclatureId : null"
                                                    @input="onNomenclatureInput($event)"
                                                    :items="nomenclatures"
                                                    :item-text="item => `${item.Code} ${item.Header}`"
                                                    item-value="id"
                                                    return-object
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="requiredRule"
                                                    append-icon="fas fa-chevron-down"
                                                    :menu-props="{ bottom: true, offsetY: true }"
                                                >
                                                    <template v-slot:prepend-item>
                                                        <v-list-item>
                                                            <v-list-item-content>
                                                                <v-text-field 
                                                                    :placeholder="$t('Поиск')"
                                                                    class="mb-2 autocomplete-search"
                                                                    hide-details
                                                                    dense
                                                                    clearable
                                                                    autofocus
                                                                    v-model="nomenclatureSearch"
                                                                >
                                                                </v-text-field>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </template>
                                                </v-select>
                                            </v-col>
                                        </v-row>

                                        <!--поле Вид документа-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{ $t("Тип_документа") }}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <div v-if="isViewMode || isProtocol" class="onlyReadData">
                                                    {{ document.Card.DocumentType ? document.Card.DocumentType.Value : $t("не_указано") }}
                                                </div>
                                                <v-select
                                                    v-else
                                                    :value="document.Card.DocumentType"
                                                    @input="update({ property: 'Data.Object.Document.Card.DocumentType', value: $event})"
                                                    :items="documentTypeItems"
                                                    :item-text="item => $refLocale(item, $i18n.locale)"
                                                    item-value="id"
                                                    return-object
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="requiredRule"
                                                    append-icon="fas fa-chevron-down"
                                                    :menu-props="{ bottom: true, offsetY: true }"
                                                >
                                                    <template v-slot:prepend-item>
                                                        <v-list-item>
                                                            <v-list-item-content>
                                                                <v-text-field 
                                                                    :placeholder="$t('Поиск')"
                                                                    class="mb-2 autocomplete-search"
                                                                    hide-details
                                                                    dense
                                                                    clearable
                                                                    autofocus
                                                                    v-model="documentTypeSearch"
                                                                >
                                                                </v-text-field>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </template>
                                                </v-select>
                                            </v-col>
                                        </v-row>

                                        <!--поле Тип протокола-->
                                        <v-row no-gutters v-if="isProtocol">
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{ $t("Тип_протокола") }}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{ document.Card.ProtocolType ? document.Card.ProtocolType.Value : $t("не_указано") }}
                                                </div>
                                                <v-select
                                                    v-else
                                                    :value="document.Card.ProtocolType"
                                                    @input="update({ property: 'Data.Object.Document.Card.ProtocolType', value: $event})"
                                                    :items="protocolTypeItems"
                                                    :item-text="item => $refLocale(item, $i18n.locale)"
                                                    item-value="id"
                                                    return-object
                                                    hide-details
                                                    outlined
                                                    dense
                                                    append-icon="fas fa-chevron-down"
                                                    :menu-props="{ bottom: true, offsetY: true }"
                                                >
                                                    <template v-slot:prepend-item>
                                                        <v-list-item>
                                                            <v-list-item-content>
                                                                <v-text-field 
                                                                    :placeholder="$t('Поиск')"
                                                                    class="mb-2 autocomplete-search"
                                                                    hide-details
                                                                    dense
                                                                    clearable
                                                                    autofocus
                                                                    v-model="protocolTypeSearch"
                                                                >
                                                                </v-text-field>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </template>
                                                </v-select>
                                            </v-col>
                                        </v-row>

                                        <!--поле Характер вопроса-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Характер_вопроса")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{ document.Card.QuestCharacter ? document.Card.QuestCharacter.Value : $t("не_указано") }}
                                                </div>
                                                <v-select
                                                    v-else
                                                    :value="document.Card.QuestCharacter"
                                                    @input="update({ property: 'Data.Object.Document.Card.QuestCharacter', value: $event })"
                                                    :items="questCharacterItems"
                                                    :item-text="item => $refLocale(item, $i18n.locale)"
                                                    item-value="id"
                                                    return-object
                                                    hide-details
                                                    outlined
                                                    dense
                                                    append-icon="fas fa-chevron-down"
                                                    :menu-props="{ bottom: true, offsetY: true }"
                                                >
                                                    <template v-slot:prepend-item>
                                                        <v-list-item>
                                                            <v-list-item-content>
                                                                <v-text-field 
                                                                    :placeholder="$t('Поиск')"
                                                                    class="mb-2 autocomplete-search"
                                                                    hide-details
                                                                    dense
                                                                    clearable
                                                                    autofocus
                                                                    v-model="questCharacterSearch"
                                                                >
                                                                </v-text-field>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </template>
                                                </v-select>
                                            </v-col>
                                        </v-row>

                                        <!--поле Язык документа-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Язык_документа")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">

                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{ document.Card.Languages ? documentLanguages.map((x) => x.Value).join(', ') : $t("не_указано") }}
                                                </div>

                                                <v-autocomplete
                                                    v-else
                                                    v-model="documentLanguages"
                                                    :items="GetReference(1000)"
                                                    :item-text="item => $refLocale(item, $i18n.locale)"
                                                    item-value="id"
                                                    multiple
                                                    return-object
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="multipleRule"
                                                    append-icon="fas fa-chevron-down"
                                                >
                                                </v-autocomplete>

                                            </v-col>
                                        </v-row>

                                        <!--поле Тип носителя-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Тип_носителя")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">

                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{document.Card.CarrierType ? document.Card.CarrierType.Value : $t("не_указано")}}
                                                </div>
                                                <v-autocomplete
                                                    v-else
                                                    :value="document.Card.CarrierType"
                                                    @input="update({ property: 'Data.Object.Document.Card.CarrierType', value: $event })"
                                                    :items="GetReference(1024)"
                                                    :item-text="item => $refLocale(item, $i18n.locale)"
                                                    item-value="id"
                                                    return-object
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="requiredRule"
                                                    append-icon="fas fa-chevron-down"
                                                >
                                                </v-autocomplete>
                                            </v-col>
                                        </v-row>

                                        <!--поле Количество ЛПЭ-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{ $t("Количество_листов/приложений") }}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">

                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{`${document.Card.ListCount}/${document.Card.AttachCount}`}}
                                                </div>
                                                <div class="more-inputs-in-row" v-else>
                                                    <v-text-field
                                                        :value="document.Card.ListCount"
                                                        @input="update({ property: 'Data.Object.Document.Card.ListCount', value: $event })"
                                                        hide-details
                                                        required
                                                        outlined
                                                        dense
                                                        type="number"
                                                        :rules="integerNotNull"
                                                        class="cust-inputnumber"
                                                        min="0"
                                                    >
                                                    </v-text-field>
                                                    <span>/</span>
                                                    <v-text-field
                                                        :value="document.Card.AttachCount"
                                                        @input="update({ property: 'Data.Object.Document.Card.AttachCount', value: $event })"
                                                        hide-details
                                                        required
                                                        outlined
                                                        dense
                                                        type="number"
                                                        :rules="integerRule.concat(requiredRule)"
                                                        class="cust-inputnumber"
                                                        min="0"
                                                    >
                                                    </v-text-field>
                                                </div>
                                            </v-col>
                                        </v-row>

                                    </v-card-text>
                                </v-card>

                            </v-col>

                            <v-col cols="12" sm="12" md="6" class="section-wrapper">

                                <DocumentStatusCard
                                    v-if="!document.is_new_record && isRegistered" 
                                    :controlInfo="controlInfo"
                                />

                                <!--Секция Исполнитель-->
                                <v-card flat>
                                    <v-card-text>
                                        <div class="form-box-title">{{ $t("Исполнитель/Автор_документа") }}</div>
                                        
                                        <!--поле Исполнитель-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Исполнитель")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div class="icon-click-row-group icrg-align-center">                                                    
                                                    <div v-if="!isViewMode" @click="onExecuterSelect">
                                                        <v-icon small v-tooltip.left-center="selectExecuterTooltip">
                                                            fas fa-edit
                                                        </v-icon>
                                                    </div>
                                                    <div class="onlyReadData">
                                                        <v-workplace-chip 
                                                            v-if="document.Card.ExecuterName" 
                                                            :id="document.Card.ExecuterWorkplaceId" 
                                                            :name="document.Card.ExecuterName" 
                                                            :canDelete="!isViewMode"                                                            
                                                            :delFunc="onRemoveExecuter"
                                                        />
                                                    </div>
                                                    <div class="chipAreaNoData d-flex align-center pl-1" v-if="!document.Card.ExecuterName && !isViewMode">
                                                        <v-select-members-chip                                            
                                                            target-type="Member"
                                                            @on-select="onSelecExecuterChip"
                                                            :items-params="membersExecuterSelectParams"
                                                            :required="true"
                                                        /> 
                                                    </div>
                                                </div>
                                            </v-col>
                                        </v-row>

                                        <!--поле Телефон исполнителя-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Телефон_исполнителя")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{ document.Card.Phone ? document.Card.Phone : $t("не_указано") }}
                                                </div>
                                                <v-text-field
                                                    v-else
                                                    :value="document.Card.Phone"
                                                    @input="update({ property: 'Data.Object.Document.Card.Phone', value: $event })"
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="requiredRule"
                                                >
                                                </v-text-field>
                                            </v-col>
                                        </v-row>

                                    </v-card-text>
                                </v-card>

                                 <!--Секция Кем создано-->
                                <v-card flat v-if="isViewMode">
                                    <v-card-text>
                                        <div class="form-box-title">{{ $t("Кем_создано") }}</div>
                                        
                                        <!--поле Сотрудник-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Сотрудник")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div class="onlyReadData">
                                                    <v-employee-chip :id="document.AuthorId" :name="document.AuthorName" />
                                                </div>
                                            </v-col>
                                        </v-row>

                                        <!--поле Дата создания-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Дата_создания")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div class="onlyReadData">{{ formatDate(document.CreateDate) }}</div>
                                            </v-col>
                                        </v-row>

                                    </v-card-text>
                                </v-card>

                            </v-col>
                            
                            <v-col cols="12" sm="12" md="12" class="section-wrapper">
                                
                                <!--Секция Краткое содержание-->
                                <v-card flat>
                                    <v-card-text>
                                        <div class="form-box-title">{{$t("Краткое_содержание")}}</div>

                                        <v-row class="full-width-row" no-gutters>
                                            <v-col cols="12" sm="12" md="2">
                                                <label class="f-label">{{$t("Краткое_содержание")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="10">
                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{document.Theme}}
                                                </div>
                                                <v-textarea v-else
                                                    :value="document.Theme"
                                                    @input="update({ property: 'Data.Object.Document.Theme', value: $event })"
                                                    rows="3"
                                                    no-resize
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="requiredRule"
                                                >
                                                </v-textarea>
                                            </v-col>
                                        </v-row>

                                    </v-card-text>
                                </v-card>

                                <!--Секция Кому адресовано-->
                                <v-card flat v-if="!isProtocol">
                                    <v-card-text>
                                        <div class="form-box-title">{{$t("Кому_адресовано")}}</div>

                                        <v-row class="full-width-row" no-gutters>
                                            <v-col cols="12" sm="12" md="2">
                                                <label class="f-label">{{$t("Получатели")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="10">
                                                <div class="icon-click-row-group">
                                                    <div v-if="!isViewMode" @click="onRecipientsSelect">
                                                        <v-icon small v-tooltip.left-center="selectRecipientsTooltip">
                                                            fas fa-edit
                                                        </v-icon>
                                                    </div>
                                                    <div class="onlyReadData more-per-lab-wrap">                                                        
                                                        <template v-if="isViewMode && (!document.Card.Recipients || document.Card.Recipients.length === 0)">{{ $t("Не_указано") }}</template>
                                                        <template v-for="recipient in document.Card.Recipients">

                                                            <v-enterprise-chip
                                                                v-if="recipient.ContractorType === 0"
                                                                :key="'en' + recipient.Id"
                                                                :name="recipient.Name"
                                                                :canDelete="!isViewMode"
                                                                :id="recipient.Id"
                                                                :delFunc="onRemoveRecipient"
                                                            />

                                                            <v-workplace-chip
                                                                v-else
                                                                :key="recipient.Id"
                                                                :id="recipient.Id"
                                                                :name="recipient.Name"
                                                                :is-employee="recipient.IsEmployee"
                                                                :canDelete="!isViewMode"                                                                
                                                                :delFunc="onRemoveRecipient"
                                                            />

                                                        </template>
                                                        <v-select-members-chip   
                                                            v-if="!isViewMode"
                                                            target-type="Member"
                                                            @on-select="onSelectRecipientChip"
                                                            :items-params="membersRecipientSelectParams"
                                                        />
                                                    </div>
                                                </div>
                                            </v-col>
                                        </v-row>

                                    </v-card-text>
                                </v-card>

                            </v-col>

                        </v-row>
                    </v-form>
                </template>

                <template v-else-if="item.FormId == 'RouteParams'">
                    <RouteParamsTab
                        :isViewMode="isViewMode"
                        :readonly="dataSource.Data.Object.ProcessInfoReadOnly"
                    />
                </template>

                <template v-else-if="item.FormId == 'Control'">
                    <ControlTab
                        :document="document"
                        :ref="item.FormId"
                    />
                </template>

                <template v-else>
                    <component
                        :is="$mapComponent(item.FormId)"
                        :ref="item.FormId"
                        :id="document.id"
                    />
                </template>                

            </v-tab-item>

        </v-tabs-items>
    </div>
</template>

<script>
import Toolbar from '@/components/Toolbar.vue';
import DocumentPanel from '@/components/DocumentPanel.vue';
import { mapActions, mapGetters } from 'vuex';
import i18n from '@/i18n'

import RouteParamsTab from '@/components/tabs/static/RouteParams';
import DocumentStatusCard from '@/components/widgets/DocumentStatus';
import ControlTab from '@/components/tabs/static/Control';
import _ from 'lodash'
import sys from '@/services/system';

export default {
    name: "InnerCard",
    components: { 
        Toolbar,
        DocumentPanel,
        RouteParamsTab,
        DocumentStatusCard,
        ControlTab
    },
    asyncComputed: {
        documentTypeItems: {
            async get () {
                let items = Array.from(await this.$store.dispatch('references/getReference', { id: 1001 }));

                if (this.documentTypeSearch)
                    return items.filter(i => sys.checkSearch(i.Value, this.documentTypeSearch) || i.id == this.document?.Card?.DocumentType?.id);
                else
                    return items;
            },
            default: [],
            watch: ['documentTypeSearch']
        },
        protocolTypeItems: {
            async get () {
                let items = Array.from(await this.$store.dispatch('references/getReference', { id: 1035 }));

                if (this.protocolTypeSearch)
                    return items.filter(i => sys.checkSearch(i.Value, this.protocolTypeSearch) || i.id == this.document?.Card?.ProtocolType?.id);
                else
                    return items;
            },
            default: [],
            watch: ['protocolTypeSearch']
        },
        questCharacterItems: {
            async get () {
                let items = Array.from(await this.$store.dispatch('references/getReference', { id: 1003 }));

                if (this.questCharacterSearch)
                    return items.filter(i => sys.checkSearch(i.Value, this.questCharacterSearch) || i.id == this.document?.Card?.QuestCharacter?.id);
                else
                    return items;
            },
            default: [],
            watch: ['questCharacterSearch']
        },
        nomenclatures : {
            async get() {
                if (this.nomenclatureSearch) {                
                    return (await this.$store.dispatch('references/getNomenclatures', { forDepartment: false }))
                        .map(x => ({ id: x[0], Code: x[1], Header: x[2] }))
                        .filter(i => sys.checkSearch(`${i.Code} ${i.Header}`, this.nomenclatureSearch) || i.id == this.nomenclature?.id);
                }
                else
                    return (await this.$store.dispatch('references/getNomenclatures', { forDepartment: false }))
                        .map(x => ({ id: x[0], Code: x[1], Header: x[2] }));
            },
            default: [],
            watch: ['nomenclatureSearch']
        }
    },
    computed: {
        ...mapGetters('references', ['GetReference']),
        ...mapGetters('actionsource', { controlInfo: 'getControlInfo', dataSource: 'getDataSource', dataSourceType: 'getDataSourceType', isCommon: 'isDataSourceCommon' }),
        ...mapGetters({ 
            requiredRule: 'getRequiredRule',
            multipleRule: 'getMultipleRule',
            integerRule: 'getIntegerRule',
            integerNotNull: 'getIntegerNotNullRule'
        }),
        ...mapGetters('auth', { userInfo: 'getUserInfo'}),
        documentLanguages: {
            get: function() {
                return this.document.Card.Languages?.data_list ?? [];
            },
            set: function(value) {
                if (this.document.Card.Languages != null)
                    this.updateSource({ property: 'Data.Object.Document.Card.Languages.data_list', value });
                else
                    this.updateSource({ property: 'Data.Object.Document.Card.Languages', value: { data_list: value } });
            }
        },
        isViewMode() {
            return this.dataSource?.Data?.FormId === "0201031";
        },
        document() {
            return this.dataSource?.Data?.Object?.Document;
        },
        pages() {
            let pages = 
            [
                { Count: -1, FormId: this.document?.id, Name: i18n.t("Карточка") }
            ];

            if ((!this.isViewMode || this.document?.ProcessInfo != null) &&
                this.document?.RegState !== 1 && !this.isProtocol)
            {
                pages.push({ Count: -1, FormId: "RouteParams", Name: i18n.t("Маршрут") });
            }

            if (this.isORD && this.isRegistered)
                pages.push({ Count: -1, FormId: "Control", Name: i18n.t("Контроль") });
            
            pages = pages.concat(this.dataSource?.Data?.Object?.Pages ?? []);

            //ЭКБ НПА
            if (this.document?.EECBActMetadata != null)
                pages.push({ Count: -1, FormId: "GovermentRegistration", Name: i18n.t("Государственная_регистрация") });

            return pages;
        },
        isRegistered(){
            return this.document?.RegState === 1 || this.document?.RegState === 4; 
        },
        isORD() {
            return this.document?.Card.TypeC4 === 1;
        },
        concatedRegistrationData() {
            let result = i18n.t("Не_указано");

            if (this.document.Card.RegNumber?.length)
                result = `№ ${this.document.Card.RegNumber}`;

            if (this.document.Card.RegDate)
                result += ` ${this.$t("от_время")} ${this.formatDate(this.document.Card.RegDate)} г.`;

            return result;
        },
        selectNomenclatureTooltip(){
            return i18n.t("Выбрать_номенклатуру");
        },
        selectExecuterTooltip(){
            return i18n.t("Выбрать_исполнителя");
        },
        selectRecipientsTooltip(){
            return i18n.t("Выбрать_получателей");
        },
        guidEmpty() {
            return sys.guidEmpty();
        },
        isProtocol: {
            get: function() {
                return this.document.Card.IsProtocol;
            },
            set: function(value) {
                this.updateSource({ property: 'Data.Object.Document.Card.IsProtocol', value});
                if (value) { 
                    this.documentTypeSearch = ""; 
                    let typeDocProtocol = this.documentTypeItems.find(item=>item.Value == "Протокол" || item.Value == "Хаттама");
                    this.updateSource({ property: 'Data.Object.Document.Card.DocumentType', value: typeDocProtocol });
                    this.updateSource({ property: 'Data.Object.Document.Card.Recipients', value: [] });
                }
            }
        },
        membersExecuterSelectParams(){
            return {
                includeInner: true,
                includeOuter: this.isORD === true,
                multiple: false,
                selected: [ this.document.Card.ExecuterWorkplaceId ]
            };
        },
        membersRecipientSelectParams(){
            return {
                multiple: true,
                includeInner: true,
                includeOuter:  this.isCommon,
                includeOuterEnterprises: this.isORD,
                includeExecutersGroups: true,
                selected: [ ...this.document.Card.Recipients.map(x => x.Id) ]
            }
        }
    },
    data() {
        return {
            tab: null,
            questCharacterSearch: "",
            documentTypeSearch: "",
            nomenclatureSearch: "",
            protocolTypeSearch: "",
        }
    },
    methods: {
        ...mapActions('actionsource', { updateSource: 'updateDataSource' }),
        onTabClicked (formId) {
            if (this.$refs[formId])
                this.$refs[formId][0]?.update();
        },
        async onToolbarClick (event, button) {
            let actions = Reflect.ownKeys(this.$store._actions).filter(i => i.includes('actionsource/')).map(i => {return i.split('/')[1]})

            if (actions.includes(button.Action)) {
                if(button.Action == 'Save' || button.Action == 'SaveAndClose'){
                    let validate_result = this.$refs.form[0].validate();
                    if(validate_result){
                        await this.$store.dispatch(`actionsource/${button.Action}`, {event, button});        
                    }else{
                        this.$notify.alert(i18n.t("Не_заполнены_обязательные_поля"));
                    }
                }
                else
                {
                    await this.$store.dispatch(`actionsource/${button.Action}`, {event, button});
                }
            }
            else
                this.$notify.alert(`Действие_${button.Action}_не_реализовано.`);
        },
        formatDate (source) {
            return this.$moment(source).format('DD.MM.YYYY');
        },
        async onNomenclatureSelect (){
            try {
                let selected = await this.$store.dispatch('dialogs/selectNomenclature/open', null);
                this.updateSource({ property: 'Data.Object.Document.Nomenclature', value: { Code: selected[1], Header: selected[2] } });
                this.updateSource({ property: 'Data.Object.Document.NomenclatureId', value: selected[0] });
            }
            catch (ex) {
                console.log(ex);
            }
        },
        async onExecuterSelect (){
            try {
                let selectMemberParams =  { 
                    title: i18n.t("Выбор_исполнителя"),
                    includeInner: true,
                    includeOuter: this.isORD === true,
                    multiple: false,
                    selected: [ this.document.Card.ExecuterWorkplaceId ]
                }
                let { workplaceId, employeeId, name, contacts } = await this.$store.dispatch('dialogs/selectMembersNew/open', selectMemberParams);                
                this.updateSource({ property: 'Data.Object.Document.Card.ExecuterName', value: name });
                this.updateSource({ property: 'Data.Object.Document.Card.ExecuterWorkplaceId', value: workplaceId });
                this.updateSource({ property: 'Data.Object.Document.Card.ExecuterId', value: employeeId });

                let phone = contacts?.find(contact => { return contact.type === "phone"; }) ?? null;
                this.updateSource({ property: 'Data.Object.Document.Card.Phone', value: phone?.value ?? null });
            }
            catch (ex) {
                console.log(ex);
            }
        },
        async onRecipientsSelect () {
            try {
                let selectMemberParams =  { 
                    title:"Выбор_получателей",
                    multiple: true,
                    includeInner: true,
                    includeOuter:  this.isCommon,
                    includeOuterEnterprises: this.isORD,
                    includeExecutersGroups: true,
                    selected: [ ...this.document.Card.Recipients.map(x => x.Id) ]
                }
                let recipients = await this.$store.dispatch('dialogs/selectMembersNew/open', selectMemberParams);
                this.updateSource(
                {
                    property: 'Data.Object.Document.Card.Recipients',
                    value: recipients.map(recipient => 
                        ({
                            ContractorType: recipient.type, Id: recipient.type === 1 ? recipient.workplaceId : recipient.enterprise,
                            IsEmployee: recipient.type === 1,
                            Name: recipient.name
                        }))
                });
            }
            catch (ex) {
                console.log(ex);
            }
        },
        onNomenclatureInput(event) {
            this.updateSource({ property: 'Data.Object.Document.Nomenclature', value: { Code: event.Code, Header: event.Header } });
            this.updateSource({ property: 'Data.Object.Document.NomenclatureId', value: event.id });
        },
        update: _.debounce(function (object) {            
            this.updateSource(object);
        }, 250),
        onRemoveExecuter() {
            this.updateSource({ property: 'Data.Object.Document.Card.ExecuterName', value: null });
            this.updateSource({ property: 'Data.Object.Document.Card.ExecuterWorkplaceId', value: '00000000-0000-0000-0000-000000000000' });
            this.updateSource({ property: 'Data.Object.Document.Card.ExecuterId', value: '00000000-0000-0000-0000-000000000000' });                
            this.updateSource({ property: 'Data.Object.Document.Card.Phone', value: null });
        },
        onSelecExecuterChip(e){
            this.updateSource({ property: 'Data.Object.Document.Card.ExecuterName', value: e.value.name });
            this.updateSource({ property: 'Data.Object.Document.Card.ExecuterWorkplaceId', value: e.value.workplaceId });
            this.updateSource({ property: 'Data.Object.Document.Card.ExecuterId', value: e.value.employeeId });

            let phone = e.value.contacts?.find(contact => { return contact.type === "phone"; }) ?? null;
            this.updateSource({ property: 'Data.Object.Document.Card.Phone', value: phone?.value ?? null });
        },
        onSelectRecipientChip(e){
            let recipients = JSON.parse(JSON.stringify(this.dataSource.Data.Object.Document.Card.Recipients));
            recipients.push({ 
                ContractorType: e.value.type, Id: e.value.type === 1 ? e.value.workplaceId : e.value.enterprise,
                IsEmployee: e.value.type === 1,
                Name: e.value.name
            });

            this.updateSource({ property: 'Data.Object.Document.Card.Recipients', value: recipients});
        },
        onRemoveRecipient(id) {
            let recipients = JSON.parse(JSON.stringify(this.dataSource.Data.Object.Document.Card.Recipients));
            this.updateSource({ property: 'Data.Object.Document.Card.Recipients', value: recipients.filter(x => x.Id != id)});
        }
    },
    async created() {
        (async() => {
            while(typeof this.$refs.form === 'undefined')
                await new Promise(resolve => setTimeout(resolve, 100));

            this.$refs?.form?.[0]?.validate();
        })();
    },
    updated() {
        if(this.dataSource !== null){
            this.$refs?.form?.[0]?.validate();
        }  
    },
    mounted() {        
        this.$eventBus.$on('set-active-tab', async ({ FormId }) => {
            let page = this.pages.find(x => x.FormId === FormId);

            if (page) {
                let targetIndex = this.pages.indexOf(page);

                if (this.tab != targetIndex)
                    this.tab = targetIndex;
                else
                    this.$eventBus.$emit('update-active-tab');
            }
        });
    },
    beforeDestroy() {
        this.$eventBus.$off('set-active-tab');
    }
}
</script>